module.exports = __webpack_public_path__ + "static/media/website_button.6c2ed927.png";